
    const data = {"name":"src/core/icons/receipt-text","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m3 22 1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2m15 7H6V7h12m0 6H6v-2h12m0 6H6v-2h12v2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            